import config from '#/config';

/** Note: There is alternative scanner https://stgscan.io/ */
function getStargateScannerUrl() {
  return `https://${config.envIsSandbox ? 'testnet.' : ''}layerzeroscan.com`;
}

/**
 * Stargate Explorer which will try to search for transaction hash
 */
export function getStargateScannerTxUrl(transactionHash: string) {
  const baseUrl = getStargateScannerUrl();
  return `${baseUrl}/tx/${transactionHash}`;
}

// export function getStargateScannerTxUrl(
//   sourceChain: ChainConfig,
//   walletAddress: string,
//   bridgeMessageNonce: number
// ) {
//   const baseUrl = getStargateScannerUrl(sourceChain);
//   const polygonChain = config.chains.___EVM;
//   getStargateBridgeChainId
//   return `${baseUrl}/${sourceChain.stargateChainId}/address/${walletAddress}/message/${polygonChain.stargateChainId}/address/${polygonChain.stargateSgReceiveAddress}/nonce/${bridgeMessageNonce}`;
// }
